import { z } from "zod";

import { auditDate } from "@/schemas";

import { environmentalChecklistItemWithTicket } from "../../../../schemas";

export const moveInMoveOutBathroomSchema = z.object({
  locationId: z.string().min(1, "Required"),
  auditDate: auditDate,
  reviewerId: z.string().min(1, "Required"),
  bathroomDescription: z.string().min(1, "Required"),
  bathroomWall: environmentalChecklistItemWithTicket,
  bathroomToilet: environmentalChecklistItemWithTicket,
  bathroomWindow: environmentalChecklistItemWithTicket,
  bathroomShower: environmentalChecklistItemWithTicket,
  bathroomCeiling: environmentalChecklistItemWithTicket,
  bathroomFloor: environmentalChecklistItemWithTicket,
  bathroomDoor: environmentalChecklistItemWithTicket,
  bathroomFixture: environmentalChecklistItemWithTicket,
  bathroomBasin: environmentalChecklistItemWithTicket,
  bathroomComment: z.string().optional(),
});
